import { render } from "./InteractionClusterItem.vue?vue&type=template&id=483e599c&ts=true"
import script from "./InteractionClusterItem.vue?vue&type=script&lang=ts"
export * from "./InteractionClusterItem.vue?vue&type=script&lang=ts"

import "./InteractionClusterItem.vue?vue&type=style&index=0&id=483e599c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__